import { render } from "./MilestoneOverviewCard.vue?vue&type=template&id=107548be&scoped=true"
import script from "./MilestoneOverviewCard.vue?vue&type=script&lang=js"
export * from "./MilestoneOverviewCard.vue?vue&type=script&lang=js"

import "./MilestoneOverviewCard.vue?vue&type=style&index=0&id=107548be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107548be"]])

export default __exports__